// extracted by mini-css-extract-plugin
module.exports = {"modalCardTitle":"LicenseFormModal_modalCardTitle_yECc2","modalCardBody__loadingOptions":"LicenseFormModal_modalCardBody__loadingOptions_3ea44"};